var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.111 13.686"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    d: "M2203.7 1029.964l-6.856 6.111-6.83-6.111z",
    className: "cls-1",
    "data-name": "Path 101",
    transform: "rotate(90 1613.043 -576.969)"
  })));
}
export default __webpack_public_path__ + "static/media/ic_previous.4de3101f.svg";
export { SvgIcPrevious as ReactComponent };